import { useDispatch, useSelector } from 'react-redux';
import { MultiSelectButton, MultiSelectSearch } from '../helpers/MultiSelect';
import { selectAdvancedCapacityComponentFilters } from '../filters/advancedFiltersSelectors';
import { advancedFiltersActions } from '../filters/advancedFiltersSlice';
import { selectTspOptions } from '../map/slice/mapSelectors';
import { useGetTSPsQuery } from '../services/edgeApi';
import { CAPACITY_TYPE_OPTIONS } from './capacityTypeOptions';

export const CapacityComponentFilters = () => {
  useGetTSPsQuery();
  const dispatch = useDispatch();

  const tspOptions = useSelector(selectTspOptions);
  const capacityComponentFilters = useSelector(
    selectAdvancedCapacityComponentFilters,
  );

  return (
    <div className="my-2 p-3">
      <div className="row">
        <div className="col">
          <MultiSelectButton
            title="Conditions"
            options={[
              { id: 'hasPoints=true', name: 'Has Points' },
              { id: 'hasPoints=false', name: 'No Points' },
              // { id: 'hasFlowActivity=true', name: 'Has Flow Activity' },
              // { id: 'hasFlowActivity=false', name: 'No Flow Activity' },
              { id: 'hasNoticeComponent=true', name: 'Has Notice Component' },
              { id: 'hasNoticeComponent=false', name: 'No Notice Component' },
              // { id: 'hasNoticeActivity=true', name: 'Has Notice Activity' },
              // { id: 'hasNoticeActivity=false', name: 'No Notice Activity' },
            ]}
            markedFirst={false}
            keyExtractor={(option) => option.id}
            isMarked={({ id }) => {
              const [field, value] = id.split('=');
              return capacityComponentFilters[field] === JSON.parse(value);
            }}
            onToggle={(option, isMarked) => {
              const [field, value] = option.id.split('=');
              const filterValue = isMarked ? JSON.parse(value) : null;
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'capacityComponents',
                  field,
                  value: filterValue,
                }),
              );
            }}
            optionRenderer={(option) => option.name}
          />
        </div>
        <div className="col">
          <input
            className="form-control"
            placeholder="Search"
            value={capacityComponentFilters.textSearch}
            onChange={(evt) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'capacityComponents',
                  field: 'textSearch',
                  value: evt.target.value,
                }),
              )
            }
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="TSP"
            options={tspOptions}
            value={capacityComponentFilters.tsps}
            onChange={(options) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'capacityComponents',
                  field: 'tsps',
                  value: options.map((option) => option.value),
                }),
              )
            }
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="Capacity Type"
            options={CAPACITY_TYPE_OPTIONS}
            value={capacityComponentFilters.capacityTypes}
            onChange={(options) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'capacityComponents',
                  field: 'capacityTypes',
                  value: options.map((option) => option.value),
                }),
              )
            }
          />
        </div>
      </div>
    </div>
  );
};
